<template>
  <div>
    <div class="flex flex-col sm:flex-row lg:w-full items-center px-4 py-2 text-left bg-yellow-50 text-yellow-700 font-semibold border border-yellow-600 dark:bg-yellow-500/30 dark:text-yellow-300 dark:border-yellow-500 my-4 rounded">
      <font-awesome-icon icon="fa-solid fa-exclamation-triangle" class="text-yellow-500 dark:text-yellow-200 mr-4 mb-2 mt-1 w-6 h-6" />
      <div>
        <p><span />Only use this if the invitation was sent by mistake.</p>
        <p>Revoking will <span class="italic">not</span> resend a welcome email.</p>
      </div>
    </div>
    <p class="w-full text-left mt-6 mb-4">
      This will revoke <span class="font-bold">{{ username }}</span>'s access and prevent them from accessing the sites within this tenant.
    </p>
    <p class="w-full text-left mb-8">
      If the user did not receive their welcome email, they can use "Forgot Password" on the login page, or contact support for assistance.
    </p>
  </div>
</template>

<script>
import { mapGetters } from "vuex"

export default {
  name: "RevokeInvitationPrompt",
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters(["getProceedArgs"]),
    username() {
      return this.getProceedArgs.username
    },
  },
}
</script>